/**
 * Phase B — Paramètres > Intégrations (admin-only).
 *
 * Historique :
 *  - Contenait la card Google Calendar → déplacée vers `/mon-compte`
 *    (Phase 2C.M) pour que chaque utilisateur (admin, commercial, secrétaire)
 *    puisse connecter son propre agenda personnel.
 *  - Ne contient plus que le bloc Peppol (paramètre d'entreprise, admin-only).
 */
export default function SettingsIntegrationsPage() {
  return (
    <div className="space-y-8" data-testid="settings-integrations-page">
      <div>
        <h2 className="text-lg font-semibold text-slate-100">Intégrations</h2>
        <p className="mt-1 text-sm text-slate-400">
          Connecte les outils externes de ton entreprise.
        </p>
        <p className="mt-2 text-xs text-slate-500">
          L'agenda Google est désormais géré au niveau utilisateur — chaque membre
          connecte son propre compte depuis <strong>Mon compte</strong>.
        </p>
      </div>
      <section data-testid="integrations-peppol">
        <h3 className="mb-2 text-sm font-semibold uppercase tracking-wide text-slate-400">
          Facturation électronique
        </h3>
        <div className="rounded-lg border border-slate-800 bg-slate-900/40 p-4 text-sm text-slate-400">
          Le réseau Peppol (Wolters Kluwer) est configuré au niveau de la
          plateforme. Contacte le support pour activer l'envoi et la réception
          de factures électroniques certifiées.
        </div>
      </section>
    </div>
  );
}
